// İSG uzmanı portalı — kişinin sahaya giriş için engellenme sebeplerinin PAYLAŞILAN formatlayıcısı
// (owner review B3-2, api-contract §34.2 + §35.3). İki yüzey AYNI iki listeden okur — eksik belge
// türleri VE eksik eğitim başlıkları — ve `reason`/`ready` gibi bir TEKİL/BİRİNCİL alan yalnız
// ETİKET seçimi içindir: "§35.3 İstemci sonucu — İzin sayfasının 'neden giremiyor' metni =
// missingDocumentTypes ∪ missingTrainings[].title; panonun entryBlocked satırı =
// missingDocumentTypes ∪ missingTrainingTitles. İki yüzey AYNI gerçeği gösterir." Belge türü
// adları §27 kayıt etiketidir (GL #7; çağıran `label`'ı geçer, bu dosya hook'suz kalır). Bu dosya o
// birleşimi TEK yerde kurar — `dashboard/ActionItemsPanel.tsx` (satır metni) VE
// `permits/PermitPersonnelPanel.tsx`/`PersonnelDrawer.tsx` (rozet/etiket listesi) BURADAN
// okur; ikisi ayrı ayrı "yalnız birincil sebebi göster" hatasına DÜŞMEZ (owner review'ın
// bulduğu tam o kusur — dashboard satırı `reason==='missingDocument'` iken eş zamanlı bir eğitim
// eksikliğini SESSİZCE düşürüyordu).

import type { DocumentTypeLabel } from './eligibility';

type TFunction = (key: string, options?: Record<string, unknown>) => string;

/**
 * Eksik belge türleri + eksik eğitim başlıklarından, HER İKİSİNİ de ayrı birer i18n cümle
 * parçası olarak döner (boş olan parça atlanır). Sıra: belge önce, eğitim sonra (§34.2/§35.3
 * "reason" birincil sıralamasıyla aynı yön). `hasUnresolvedTraining` — eğitim eksikliği VAR ama
 * başlıkları çözülemedi/silinmiş (§34.2 "reason='missingTraining' iken missingTrainingTitles=[]
 * MEŞRUDUR" / §35.3 "completedTrainingCount < requiredTrainingCount iken [] meşrudur" — durum
 * SAYIDAN okunur) — bu bayrak true iken `missingTrainingTitles` boş olsa bile jenerik "eğitim
 * eksik" parçası eklenir.
 */
export function blockingReasonFragments(
  missingDocumentTypes: string[],
  missingTrainingTitles: string[],
  hasUnresolvedTraining: boolean,
  t: TFunction,
  label: DocumentTypeLabel,
): string[] {
  const fragments: string[] = [];
  if (missingDocumentTypes.length > 0) {
    fragments.push(
      t('dashboard.actions.reason.missingDocument', {
        document: missingDocumentTypes.map((d) => label('personnel', d)).join(', '),
      }),
    );
  }
  if (missingTrainingTitles.length > 0) {
    fragments.push(
      t('dashboard.actions.reason.missingTraining', { training: missingTrainingTitles.join(', ') }),
    );
  } else if (hasUnresolvedTraining) {
    fragments.push(t('dashboard.actions.reason.missingTraining.generic'));
  }
  return fragments;
}

/**
 * Eksik eğitim başlıklarını, izin detayının Personel Sheet'indeki (`PersonnelDrawer.tsx`)
 * belge-eksikliği rozet listesiyle AYNI biçimde — birer Tag etiketi olarak — döner. Başlık yoksa
 * ama eksiklik VARSA (`hasUnresolvedTraining`, bkz. `blockingReasonFragments`), dashboard satırıyla
 * AYNI jenerik metni (`dashboard.actions.reason.missingTraining.generic`) TEK elemanlı dizi olarak
 * döner — iki yüzey bu uç durumda da AYNI kelimeyi kullanır.
 */
export function missingTrainingChipLabels(
  missingTrainingTitles: string[],
  hasUnresolvedTraining: boolean,
  t: TFunction,
): string[] {
  if (missingTrainingTitles.length > 0) {
    return missingTrainingTitles;
  }
  return hasUnresolvedTraining ? [t('dashboard.actions.reason.missingTraining.generic')] : [];
}
